import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./app/store"
import App from "./App"
import "./index.css"

import { Config } from "./types"

export default class AppApi {
  private container: any
  private root: any
  private options: Config
  private selector: string

  constructor(selector: string, options: Config) {
    this.selector = selector
    this.options = options
  }

  render() {
    this.container = document.querySelector(this.selector)!
    this.root = createRoot(this.container)
    this.root.render(
      //<React.StrictMode>
      <Provider store={store}>
        <App options={this.options} />
      </Provider>,
      //</React.StrictMode>
    )
  }
}
